import { bb } from "$json";
/* change-earlier:
 *
 * Allow immediate editing of previous questions
 *
 * Author: Niels Giesen
 * Copyright 2016 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  function getItem(node) {
    if (node.nodeName === "LI") return node;
    while (((node = node.parentNode), !(node.nodeName === "LI")));
    return node;
  }

  function editme(ev) {
    var item = getItem(ev.target),
      id = this.getAttribute("data-id"),
      name = id.replace(/^i/, "radio"),
      groupid = $(this).parents(".group").data("groupid"),
      idx = -1,
      before = item;

    while (((before = before.previousElementSibling), idx++, before));

    function then(event, data) {
      bb.ajax.release();
      if (data && data.groups) {
        var params = {
          step: "next",
          sessionid: data.sessionid,
          dbname: data.dbname,
          uniqueid: data.uniqueid,
          fmt: "json"
        };

        // Set radioxxx=idx
        params[name] = idx;
        bb.ajax.post({ data: params });
        // Unset important objects to prevent superfluous
        // rendering right now
        delete data.groups;
        delete data.informationsources;
        delete data.lasterrors;
        delete data.jumplist;

        $(doc).off("bb:preHandleData", then);
      }
    }

    $(doc).on("bb:preHandleData", then);

    bb.gotonode(groupid);
    return false;
  }

  $(function () {
    $(doc).on("click", ".group:not(.selected) .radiogroup", editme);
  });

  $(doc).on("bb:postHandleData", function (event, data) {
    if (data && data.groups) $(".group:not(.selected)").prop("disabled", false);
    $(".group:not(.selected) .radiogroup :input[disabled]").prop(
      "disabled",
      false
    );
  });
})(jQuery, window, document);
